module.exports = __webpack_public_path__ + "static/example-card-one-svg.82903d6c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/example-card-one-svg.svg
// module id = 906
// module chunks = 35783957827783 112643250470497